// AgencyInvoicesTab's reads and its rows' status writes (finance-real, the user 2026-10-22): every client's invoices and
// every team invoice in one list; for a new client invoice, its client's done and active jobs (an open one's drawer is the page's,
// AgencyJobInvoiceDrawer); and either kind's status picked on its row.
import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import { useClientJobs, useSetInvoiceStatus } from "../../hooks/useLineJobs";
import { useAgencyInvoiceList, useSetTeamInvoiceStatus } from "../../hooks/useTeamInvoices";
import type { AgencyInvoiceListResponse, ClientJobsResponse, JobInvoice, JobInvoiceStatusInput, TeamInvoice, TeamInvoiceStatusInput } from "../../types";

export interface AgencyInvoicesTabModel {
  invoicesQuery: UseQueryResult<AgencyInvoiceListResponse>;
  /** The client's read, for its done and active jobs: the one a new invoice is for; idle otherwise. */
  clientQuery: UseQueryResult<ClientJobsResponse>;
  setInvoiceStatus: UseMutationResult<JobInvoice, Error, { invoiceId: string; input: JobInvoiceStatusInput }>;
  setTeamStatus: UseMutationResult<TeamInvoice, Error, { invoiceId: string; input: TeamInvoiceStatusInput }>;
}

export function useAgencyInvoicesTab(newForClient: string | null): AgencyInvoicesTabModel {
  const invoicesQuery = useAgencyInvoiceList();
  const clientQuery = useClientJobs(newForClient ?? undefined);
  const setInvoiceStatus = useSetInvoiceStatus();
  const setTeamStatus = useSetTeamInvoiceStatus();
  return { invoicesQuery, clientQuery, setInvoiceStatus, setTeamStatus };
}
